module.exports = __webpack_public_path__ + "img/conception-engineering-1.3d590eb2.jpeg";